import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import App from './App';
import AdminLogin from './screens/AdminLogin';
import AdminDashboard from './screens/AdminDashboard';
import { AdminProvider, useAdmin } from './admin/AdminContext';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
    const { isAuthenticated } = useAdmin();
    if (!isAuthenticated) return <Navigate to="/admin/login" replace />;
    return <>{children}</>;
}

export default function RootRouter() {
    return (
        <AdminProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<App />} />
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route
                        path="/admin"
                        element={
                            <ProtectedRoute>
                                <AdminDashboard />
                            </ProtectedRoute>
                        }
                    />
                    {/* Preserve query/hash on unknown paths by rendering the app instead of redirecting */}
                    <Route path="*" element={<App />} />
                </Routes>
            </BrowserRouter>
        </AdminProvider>
    );
}
